export default __webpack_public_path__ + "static/char-s-52-en-9f294d1e4c3268417bef5d7c6914e903.webp";